module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/vicenza.597175ceff8d69ebae9c41316f5e065c.jpg";